module.exports = __webpack_public_path__ + "static/media/5.7c5bcf97.jpg";